import React from "react";
import Moment from "moment";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";

import { Gender } from "types/user";
import { Game, IndexedGames } from "types/game";

import HomeIcon from "assets/images/icons/house_100px.png";

interface Props extends WithStyles {
  gameId: string;
  games: IndexedGames;
}

const StartSheetHeader = (props: Props) => {
  const { classes, gameId, games } = props;
  const game = games[gameId];
  let linkedGames = (game.linkedGames || [])
    .map(id => games[id])
    .filter((linked): linked is Game => Boolean(linked));
  if (linkedGames.length === 0) linkedGames = [game];

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div className={"row flex-start space-between normal-margin"}>
          <div style={{ flex: 1 }}>
            <p className={classes.title}>{game.course.club.name}</p>
            <p className={classes.title}>{game.course.name}</p>
            {linkedGames.map(linkedGame => (
              <div className={"row"} key={linkedGame._id}>
                <p className={classes.title}>{linkedGame.name}</p>
                <p className={classes.title}>{linkedGame.code}</p>
              </div>
            ))}
            <p className={classes.subtitle}>{Moment(game.date).format("LLL")}</p>
          </div>
          <div style={{ flex: 0, height: "100px" }}>
            <img src={HomeIcon} alt="home icon" />
          </div>
        </div>
        <div className={"col normal-margin"}>
          {Object.values(game.scoreCards).map(scoreCard => (
            <p className={classes.subtitle}>
              <strong>Tee ({scoreCard.gender === Gender.Men ? "M" : "L"})</strong> ({scoreCard.teeColor}), (
              {scoreCard.courseRating}), ({scoreCard.slope})
              {` Yds ${scoreCard.holesParams.reduce(
                (total: number, hole) => total + hole.yards,
                0,
              )} Par ${scoreCard.holesParams.reduce((total: number, hole) => total + hole.par, 0)}`}
            </p>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    container: {
      // Default styles: visible
      display: "block", // Or 'flex', 'grid', etc. depending on desired default layout behaviour

      // Media Query: Hide the element on screens 500px wide or smaller
      "@media (max-width: 500px)": {
        display: "none",
      },
    },
    title: {
      margin: 4,
      flex: 1,
      fontSize: 16,
      fontWeight: "bold",
    },
    subtitle: {
      margin: 4,
      flex: 1,
      fontSize: 14,
      color: "#5c5c5c",
    },
  });

export default withStyles(styles)(StartSheetHeader);
